import { useEffect } from 'react';
import '/assets/styles/pages/web-menu-category.scss';

// Partials
import Loader from '/views/partials/loader';
import Pricebox from '/views/partials/pricebox';
import Link from '@wearetla/tla-essentials-tools/partials/link';
import Img from '@wearetla/tla-essentials-tools/partials/img';

// Sections
import WebPageHeader from '/views/sections/web-page-header';

// Context
import { useApplication } from '/utilities/application';
import { useBranchSelection } from '/utilities/branch-selection';
import { useMenu } from '/utilities/menu';
import { useNavigator, useParams } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';
import { useTranslation } from '/utilities/i18n';

const WebMenuCategory = () => {
	const { isApplication } = useApplication();
	const { setActiveBranch } = useBranchSelection();
	const { branchSlug, id: categoryId } = useParams('webMenuCategory');
	const { openModal } = useModals();
	const { redirect } = useNavigator();
	const { getMenuCategory, loadMenuCategory } = useMenu();
	const { t } = useTranslation();

	const category = getMenuCategory(branchSlug, categoryId);

	useEffect(() => {
		if (branchSlug && categoryId) {
			loadMenuCategory(branchSlug, categoryId).catch((feedback) => {
				redirect('home');
				openModal('message', { feedback });
			});
		}
	}, [branchSlug, categoryId, loadMenuCategory]);

	useEffect(() => {
		if (isApplication && branchSlug && categoryId) {
			setActiveBranch(branchSlug).then(() => {
				redirect('menuCategory', { id: categoryId });
			});
		}
	}, [branchSlug, categoryId, isApplication]);

	return (
		<>
			<Loader full solid dark loading={isApplication} />
			<WebPageHeader
				className="category-header"
				backLink={branchSlug ? { href: 'webMenu', params: { branchSlug } } : undefined}
				title={category?.title}
				showBranchName
			/>

			<div className="category-container loader-container">
				<Loader dark loading={!category} />
				{category?.products && (
					<div className="wrapper">
						<ul className="category-products">
							{category.products.map((product) => (
								<li className="products-product" key={product.id}>
									<Link
										className="product-link"
										href="webMenuProduct"
										params={{ branchSlug, id: product.id }}
									>
										<div className="product-imagewrap">
											<Img src={product.image} className="product-image" />
										</div>
										<div className="product-textarea">
											<strong className="product-title">{product.title}</strong>

											<div className="product-description">{product.description}</div>
											<Pricebox className="product-price" colored price={product.old_price} />
										</div>
									</Link>
								</li>
							))}
						</ul>
						<div className="category-updatedate">
							{t('Fiyat güncellenme tarihi')}: <strong>{category.updated_at_formatted}</strong>
						</div>
					</div>
				)}
			</div>
		</>
	);
};

export default WebMenuCategory;
